import React, { useContext } from 'react'
import logo from '../Image/Sportyan.svg'
import logodark from '../Image/Sportyan-dark.svg'
import moon from '../Image/moon.png'
import sun from '../Image/sun.png'
import {useHistory} from "react-router-dom"
import { UserContext } from '../Context/UserContext'
import { Layout, Menu, Row, Col } from 'antd'
import { UserOutlined, SearchOutlined, ShoppingCartOutlined, LogoutOutlined, LoginOutlined, FormOutlined } from "@ant-design/icons"
import { ProfileContext } from '../Context/ProfileContext'
import { WalletContext } from '../Context/WalletContext'
import SwitchTheme from './SwitchTheme'
import { ThemeContext } from '../Context/ThemeContext'

const { Header } = Layout

function LayoutHeader() {
  const [user, setUser] = useContext(UserContext)
  const [, setUserProfile] = useContext(ProfileContext)
  const [, setUserWallet] = useContext(WalletContext)
  const [,,, setDashboard] = useContext(UserContext)
  const [,,,, keyMenu] = useContext(UserContext)
  const [theme] = useContext(ThemeContext)
  const history = useHistory()

  const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''
  const changeLogo = theme === 'dark' ? logodark : theme === 'light' ? logo : ''
  
  const menuItems = [
    {label: <img src={changeLogo} alt="logo sportyan"/>, key: "/"},
    {label: "Explore", key: "/product", icon: <SearchOutlined />},
    {label: "Cart", key: "/cart", icon: <ShoppingCartOutlined />}
  ]

  let menuIsUser = [
    { label: "Dashboard", key: "/dashboard", icon: <UserOutlined/>},
    { label: "Logout", key: "/logout", icon: <LogoutOutlined/>}
  ]

  let menuIsNotUser = [
    { label: "Login", key: "/login", icon: <LoginOutlined/>},
    { label: "Register", key: "/register", icon: <FormOutlined/>}
  ]

  const HandleNavigate = (props) => {
    setDashboard(false)
    history.push(props.key)
  }

  const HandleNavigateAuth = (props) => {
    if(props.key === "/logout") {
      setDashboard(false)
      setUser(null)
      setUserProfile(null)
      setUserWallet(null)
      localStorage.clear()
      window.location.reload()
      history.push("/login")
    } else if (props.key === "/dashboard"){
      setDashboard(true)
      history.push(props.key)
    } else if (props.key === "/profile"){
      setDashboard(true)
      history.push(props.key)
    }else {
      setDashboard(false)
      history.push(props.key)
    } 
  }

  return (
    <> 
    <Header className={changeNameClass}>
      <Row className={changeNameClass}>
        <Col span={15}>
          <Menu mode="horizontal" className={changeNameClass} items={menuItems}
            onClick={HandleNavigate} key={[menuItems.key]} defaultSelectedKeys={keyMenu}
          />
        </Col>

        <Col span={3}>
        <img src={sun} style={{width: "25px", margin: "5px"}} alt="sun" />
        <SwitchTheme/>
        <img src={moon} style={{width: "25px", margin: "5px"}} alt="moon" />
        </Col>

        <Col span={6}>
          {user ?
          <Menu mode="horizontal" className={changeNameClass} items={menuIsUser} onClick={HandleNavigateAuth} key={[menuIsUser.key]} defaultSelectedKeys={keyMenu}/>
          :
          <Menu mode="horizontal" className={changeNameClass} items={menuIsNotUser} onClick={HandleNavigateAuth} key={[menuIsNotUser.key]} defaultSelectedKeys={keyMenu}/>
          }
        </Col>
      </Row>
    </Header>
    </>  
  );
}

export default LayoutHeader;